import { createContext } from 'react';

const CommentContext = createContext({
  comments: null,
  setComments: () => {},
});

export default CommentContext;